export const tiposPesquisaSatisfacao = [
  {
    tipoPesquisaSatisfacao: 'Assistência Técnica',
    textoNotificacao:
      'Queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoNotificacaoPrazoAcabando:
      'O prazo está acabando, queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoPesquisa:
      'Com sua opinião conseguiremos melhorar nossos processos, e te proporcionar uma experiência cada vez melhor! Em relação a sua solicitação de [tipo], qual a sua satisfação sobre os itens a seguir:',
  },
  {
    tipoPesquisaSatisfacao: 'Comercial',
    textoNotificacao:
      'Queremos ouvir você! Acesse aqui e avalie seu atendimento!',
    textoNotificacaoPrazoAcabando:
      'O prazo está acabando, queremos ouvir você! Acesse aqui e avalie seu atendimento!',
    textoPesquisa:
      'Com sua opinião conseguiremos melhorar nossos processos, e te proporcionar uma experiência cada vez melhor! Em relação ao seu atendimento durante a sua compra, qual a sua satisfação sobre os itens a seguir:',
  },
  {
    tipoPesquisaSatisfacao: 'Contrato de financiamento',
    textoNotificacao:
      'Queremos ouvir você! Acesse aqui e avalie seu atendimento!',
    textoNotificacaoPrazoAcabando:
      'O prazo está acabando, queremos ouvir você! Acesse aqui e avalie seu atendimento!',
    textoPesquisa:
      'Com sua opinião conseguiremos melhorar nossos processos, e te proporcionar uma experiência cada vez melhor! Em relação ao seu atendimento durante o processo de financiamento, qual a sua satisfação sobre os itens a seguir:',
  },
  {
    tipoPesquisaSatisfacao: 'Relacionamento',
    textoNotificacao:
      'Queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoNotificacaoPrazoAcabando:
      'O prazo está acabando, queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoPesquisa:
      'Com sua opinião conseguiremos melhorar nossos processos e te proporcionar uma experiência cada vez melhor. Considerando uma escala de 0 a 10:',
  },
  {
    tipoPesquisaSatisfacao: 'Vistoria',
    textoNotificacao:
      'Queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoNotificacaoPrazoAcabando:
      'O prazo está acabando, queremos ouvir você! Acesse aqui e avalie nosso serviço de [tipo]!',
    textoPesquisa:
      'Com sua opinião conseguiremos melhorar nossos processos, e te proporcionar uma experiência cada vez melhor! Em relação a sua solicitação de [tipo], qual a sua satisfação sobre os itens a seguir:',
  },
];

export const getSurvey = (survey, tiposSolicitacoes) => {
  if (tiposSolicitacoes.length > 0) {
    const pesquisa = tiposPesquisaSatisfacao.filter(
      (p) =>
        p?.tipoPesquisaSatisfacao?.toLowerCase() ===
        survey?.TipoPesquisaSatisfacao?.toLowerCase()
    );

    const clonedPesquisa = { ...pesquisa[0] };

    const tipoPesquisaSatisfacao =
      clonedPesquisa.tipoPesquisaSatisfacao?.toLowerCase();
    if (
      tipoPesquisaSatisfacao === 'relacionamento' ||
      tipoPesquisaSatisfacao === 'vistoria' ||
      tipoPesquisaSatisfacao === 'assistência técnica'
    ) {
      const tipo = getTipoSolicitacaoSubgrupo(
        survey.Subgrupo,
        tiposSolicitacoes
      ).toLowerCase();

      clonedPesquisa.textoNotificacao = pesquisa[0]?.textoNotificacao.replace(
        '[tipo]',
        tipo
      );
      clonedPesquisa.textoNotificacaoPrazoAcabando =
        clonedPesquisa?.textoNotificacaoPrazoAcabando.replace('[tipo]', tipo);

      clonedPesquisa.textoPesquisa = pesquisa[0]?.textoPesquisa.replace(
        '[tipo]',
        tipo
      );
    }

    return clonedPesquisa;
  }
};

export const getTipoSolicitacaoSubgrupo = (subgrupo, tiposSolicitacoes) => {
  return tiposSolicitacoes.filter((s) => s.tipoSalesForce === subgrupo)[0]
    ?.tipo;
};
